import { QuarterlyAnalytics } from 'commons/types/DTO/bank/companyDetails/quarterlyAnalytics'
import { DateTime, Link } from 'ui/components'
import { QuarterlyReportStatusLabel } from 'ui/components/Labels'
import { TableActions, TableColumn } from 'ui/components/Table'

export const columns = (onDelete: (item: any) => void): TableColumn<QuarterlyAnalytics>[] => [
  {
    title: 'Period',
    align: 'center',
    sortable: false,
    render: (item) => (
      <Link to="/qr/$id" params={{ id: item.id.toString() }}>
        {item.period}
      </Link>
    )
  },
  {
    title: 'Status',
    align: 'center',
    sortable: false,
    render: ({ status }) => <QuarterlyReportStatusLabel name={status} />
  },
  {
    title: 'Last Modified Date',
    sortable: false,
    render: ({ lastModifiedDate }) => <DateTime date={lastModifiedDate} withTime />
  },
  {
    title: 'Actions',
    sortable: false,
    width: '100px',
    render: (item) => (
      <TableActions
        items={[
          {
            type: 'delete',
            onClick: () => onDelete(item)
          }
        ]}
      />
    )
  }
]
